<script >import { Box } from "cannon-es";
import { toVec3 } from "../../conversion-fns";
import { syncVec3 } from "../../sync-fns";
import Shape from "../Shape.svelte";
export let size;
export let offset = undefined;
export let orientation = undefined;
export let material = undefined;
const shape = new Box(toVec3(size));
$: sync(size);
function sync(options) {
    syncVec3(shape.halfExtents, options);
    shape.updateConvexPolyhedronRepresentation();
    shape.updateBoundingSphereRadius();
}
</script>

<Shape {shape} {offset} {orientation} {material}>
  <slot />
</Shape>
